import type React from "react";
import { ReactComponent as Svg } from "./assets/account.svg";
import * as styles from "./Icon.module.scss";

type AccountProps = React.SVGProps<SVGSVGElement>;

export const Account = ({ className, ...props }: AccountProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
